import React, { useRef } from 'react';
import { FileInputWUT } from '../../../inputs/file-input/file-input-wut';
import { useTranslation } from '../../../contexts/translation-context';
import styles from './signature-upload-wut.module.scss';
import { dataUrlToWixFile } from '../utils/data-url';
export const SignatureUploadWUT = _ref => {
  let {
    id,
    onFocus,
    onBlur,
    disabled,
    required = false,
    readOnly,
    ariaLabelledBy,
    ariaDescribedBy,
    handleChange,
    hasError = false
  } = _ref;
  const {
    t
  } = useTranslation();
  const fileUploadButtonRef = useRef(null);
  const fileInputRef = useRef(null);
  const textBelowButtonRef = useRef(null);
  const handleFileChange = files => {
    if (!files || files.length === 0) {
      handleChange(null);
      return;
    }
    const file = files[0];
    const fileReader = new FileReader();
    fileReader.onload = function () {
      handleChange(dataUrlToWixFile(this.result, file.name));
    };
    fileReader.readAsDataURL(file);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement(FileInputWUT, {
    onFocus: onFocus,
    onBlur: onBlur,
    disabled: disabled || readOnly,
    buttonText: t('field.signature.settings.upload-button.label'),
    valueSliderLimit: 1,
    required: required,
    inputId: id,
    ariaLabelledBy: ariaLabelledBy,
    ariaDescribedBy: ariaDescribedBy,
    files: [],
    handleChange: handleFileChange,
    accept: "image/*",
    fileUploadButtonRef: fileUploadButtonRef,
    fileInputRef: fileInputRef,
    textBelowButtonRef: textBelowButtonRef,
    hover: false,
    fieldId: id,
    hasError: hasError,
    "data-hook": "signature-upload"
  }));
};
//# sourceMappingURL=signature-upload-wut.js.map